export default class SportingStatistics {
  constructor ({ total_distance = 0, total_time = 0, ...sporting_statistics } = {}) {
    this.total_distance = total_distance
    this.total_time = total_time

    Object.assign(this, sporting_statistics)
  }

  get to_km () {
    return this.total_distance / 1000
  }

  get is_less_than_one_hour () {
    return this.total_time / 3600 < 1
  }

  get to_minutes () {
    return Math.round(this.total_time / 60)
  }

  get to_hours () {
    return Math.round(this.total_time / 3600)
  }
}
